import { getProjectGroupingCookieName } from "@/lib/projectGroupingCookie.shared";

export const ORG_COOKIE = "x-org-id";
export const TEAM_COOKIE = "x-team-id";
export const LAST_ORG_COOKIE = "last-org-id";

export function buildResolveLoginPath(
  locale: string,
  returnTo?: string,
  org?: string,
  error?: string,
  invited?: boolean,
): string {
  const loginParams = new URLSearchParams();
  if (error) loginParams.set("error", error);
  if (invited) loginParams.set("invited", "1");

  if (returnTo || org) {
    const resolveParams = new URLSearchParams();
    if (returnTo) resolveParams.set("returnTo", returnTo);
    if (org) resolveParams.set("org", org);
    loginParams.set("returnTo", `/${locale}/resolve?${resolveParams}`);
  }

  const query = loginParams.toString();
  return `/${locale}/login${query ? `?${query}` : ""}`;
}

export function buildResolvePath(orgId: string, teamId: string, returnTo: string, groupBy?: string | null): string {
  let finalTargetPath = returnTo || "files";
  if (finalTargetPath === "files" && groupBy) {
    finalTargetPath = `grouped-projects?groupBy=${encodeURIComponent(groupBy)}`;
  }
  return `/${orgId}/${teamId}/${finalTargetPath}`;
}

export function getProjectGroupingFromCookies(
  orgId: string,
  teamId: string,
  getCookie: (name: string) => string | undefined,
): string | null {
  return getCookie(getProjectGroupingCookieName(orgId, teamId)) ?? null;
}
